import { render } from "./ThePreloader.vue?vue&type=template&id=645f936d"
import script from "./ThePreloader.vue?vue&type=script&lang=js"
export * from "./ThePreloader.vue?vue&type=script&lang=js"

import "./ThePreloader.vue?vue&type=style&index=0&id=645f936d&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__